export const apiBaseUrl = location.protocol + "//" + location.hostname + process.env.VUE_APP_API_BASE_URL;
export const apiBaseUrlDownload = location.protocol + "//" + location.hostname + process.env.VUE_APP_API_BASE_URL_DOWNLOAD;
export const baseUrl = location.protocol + "//" + location.hostname + process.env.VUE_APP_BASE_URL;         
    